import { normalize, schema } from "normalizr";

export const normalizeUserArray = (originalUsers) => {
  const userSchema = new schema.Entity("user");

  const users = new schema.Array(userSchema);

  return normalize(originalUsers, users);
};

export const getPublicIP = () => {
  return fetch("https://api.ipify.org?format=json")
    .then((response) => response.json())
    .then((data) => data)
    .catch((error) => error);
};
